import { fuzzyDateParse } from "../../util.js";
import { createMappingWarning, parseAmount } from "../utils.js";
export function mapPensionDocumentToIncome(pensionDoc, customerId) {
    const errors = [];
    const warnings = [];
    const sections = {};
    // Extract pension information from the document
    const pensionSections = [];
    // Process pension totals
    if (pensionDoc.pensionTotal) {
        for (const [categoryKey, categoryValues] of Object.entries(pensionDoc.pensionTotal)) {
            for (const category of categoryValues) {
                // Calculate total pension amount from amount details
                let totalAmount = 0;
                for (const amountDetail of category.amountDetails ?? []) {
                    const amount = parseAmount(amountDetail.amount);
                    if (amount) {
                        totalAmount += amount;
                    }
                }
                if (totalAmount === 0) {
                    continue;
                }
                // Determine pension start date
                let pensionStartDate = "";
                if (category.startAge &&
                    typeof category.startAge === "object" &&
                    "year" in category.startAge) {
                    const birthDate = fuzzyDateParse(pensionDoc.dateOfBirth, {
                        twoDigitYearCentury: "past",
                    });
                    if (birthDate.isValid) {
                        pensionStartDate = birthDate
                            .plus({
                            years: category.startAge.year ?? 0,
                            months: category.startAge.month ?? 0,
                        })
                            .startOf("month")
                            .toISODate();
                    }
                }
                // Determine payment end date
                let paymentEndDate = "";
                if (category.endAge &&
                    typeof category.endAge === "object" &&
                    category.endAge?.condition !== "Overlijden") {
                    const birthDate = fuzzyDateParse(pensionDoc.dateOfBirth, {
                        twoDigitYearCentury: "past",
                    });
                    if (birthDate.isValid) {
                        paymentEndDate = birthDate
                            .plus({
                            years: category.endAge.year ?? 0,
                            months: category.endAge.month ?? 0,
                        })
                            .startOf("month")
                            .toISODate();
                    }
                }
                const pensioen = {
                    institution: category.description || categoryKey,
                    pensionStartDate,
                    paymentEndDate,
                    grossYearlyPayment: totalAmount,
                    percentageCounted: 1,
                };
                pensionSections.push({
                    id: `pensioen-${globalThis.crypto.randomUUID()}`,
                    sectionKey: "pensioen",
                    values: pensioen,
                });
            }
        }
    }
    if (pensionSections.length > 0) {
        sections.pensioen = pensionSections;
    }
    // Add warnings for missing data
    if (pensionDoc.missingData && pensionDoc.missingData.length > 0) {
        for (const missingItem of pensionDoc.missingData) {
            warnings.push(createMappingWarning("pension-document.missingData", `Missing pension data: ${missingItem}`, missingItem));
        }
    }
    const income = {
        customerId,
        sections,
    };
    return { income, errors, warnings };
}
